// Run E2 J2 (D31): class setup wording for K-5 Project Explore, shared by the
// Create Class modal and the Manage Class edit form. English and Spanish.

/**
 * School terms offered in the "Term" select: the current term and the next
 * three, worked out from today's date (Spring = Jan-May, Summer = Jun-Jul,
 * Fall = Aug-Dec). Values keep the stored format ("Fall 2026"). A saved value
 * that is no longer in the list (an older term) is kept at the top so editing
 * a class never changes it by accident.
 */
export function termOptions(current?: string | null, today: Date = new Date()): string[] {
  const seasons = ["Spring", "Summer", "Fall"] as const;
  const month = today.getMonth(); // 0 = January
  let idx = month <= 4 ? 0 : month <= 6 ? 1 : 2;
  let year = today.getFullYear();
  const list: string[] = [];
  for (let i = 0; i < 4; i++) {
    list.push(`${seasons[idx]} ${year}`);
    idx += 1;
    if (idx > 2) {
      idx = 0;
      year += 1;
    }
  }
  if (current && !list.includes(current)) list.unshift(current);
  return list;
}

/** The term that is in progress today (first entry of termOptions()). */
export function currentTerm(today: Date = new Date()): string {
  return termOptions(null, today)[0];
}

const TERM_ES: Record<string, string> = {
  Spring: "Primavera",
  Summer: "Verano",
  Fall: "Otoño",
};

/** Display label for a stored term value ("Fall 2026" -> "Otoño 2026" in ES). */
export function termLabel(value: string, lang: "en" | "es"): string {
  if (lang !== "es") return value;
  const [season, year] = value.split(" ");
  return TERM_ES[season] ? `${TERM_ES[season]} ${year ?? ""}`.trim() : value;
}

export const CLASS_FORM_T = {
  en: {
    createTitle: "Create New Class",
    className: "Class Name*",
    classNamePlaceholder: "e.g., 2nd Grade Reading",
    classTime: "Class Time",
    classTimePlaceholder: "e.g., 9:00 AM to 9:45 AM",
    term: "Term",
    gradeType: "Grade Type",
    description: "Description",
    descriptionPlaceholder: "Brief description of the class",
    joinCode: "Generate class join code",
    joinCodeHelp: "Students can use this code to join your class without manual enrollment",
    cancel: "Cancel",
    create: "Create Class",
    creating: "Creating...",
    save: "Save Changes",
    saving: "Saving...",
  },
  es: {
    createTitle: "Crear una clase",
    className: "Nombre de la clase*",
    classNamePlaceholder: "p. ej., Lectura de 2.º grado",
    classTime: "Horario de la clase",
    classTimePlaceholder: "p. ej., 9:00 a. m. a 9:45 a. m.",
    term: "Período escolar",
    gradeType: "Tipo de calificación",
    description: "Descripción",
    descriptionPlaceholder: "Una breve descripción de la clase",
    joinCode: "Crear un código para unirse a la clase",
    joinCodeHelp: "Los estudiantes pueden usar este código para unirse a tu clase sin que tengas que inscribirlos",
    cancel: "Cancelar",
    create: "Crear la clase",
    creating: "Creando...",
    save: "Guardar los cambios",
    saving: "Guardando...",
  },
};
